const OwnLeaseValues = {
    OWN: 'own',
    LEASE: 'lease',
    FINANCE: 'finance',
};

export default OwnLeaseValues;
